import { diffBetweenDates } from './date';
const isFirstShowDateValidForConnectivityPopup = firstShowDate => {
    var _a;
    if (!firstShowDate) {
        return true;
    }
    const JUNE_10_TH = new Date(2024, 5, 10);
    return ((_a = diffBetweenDates(firstShowDate, JUNE_10_TH)) === null || _a === void 0 ? void 0 : _a.days) > 0;
};
export { isFirstShowDateValidForConnectivityPopup };
